<template>
  <a v-if="isPlainAnchor" :href="to" v-bind="externalAttrs"><slot /></a>
  <NuxtLink v-else :to="to"><slot /></NuxtLink>
</template>

<script setup lang="ts">
/**
 * 共通chrome のリンク。内部ルートは `NuxtLink`、外部URL・`tel:`・未定の `#` は素の `<a>` で出す。
 * 未定の飛び先（Note の URL 等）が `#` のまま入るため、`NuxtLink` に渡すとルーターが解決に失敗する。
 */
type Props = {
  to: string;
  external?: boolean;
};
const props = withDefaults(defineProps<Props>(), { external: false });

const isPlainAnchor = computed<boolean>(
  () => props.external || props.to === '#' || /^(https?:|tel:|mailto:)/.test(props.to)
);

const externalAttrs = computed(() =>
  /^https?:/.test(props.to) ? { target: '_blank', rel: 'noopener noreferrer' } : {}
);
</script>
